import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SHIP_TYPES } from "features/constants";
import { currencyFormat, getModalButtonClass } from "features/functions";
import { setCartActiveTab } from "features/cart/cartSlice";
import { fetchPaymentCardListIfNeeded } from "features/cart/paymentCardSlice";
import CartShipTo from "./CartShipTo";
import CartShipDealer from "./CartShipDealer";

export default function CartShip() {
	const dispatch = useDispatch();
	// Selectors
	const { cartObject, shipType, showTab, shipAddress, shipLocationId } = useSelector((state) => state.cart);
	// Handlers
	function handlePrevClick() {
		dispatch(setCartActiveTab({ showTab: showTab - 1 }));
	}
	function handleNextClick() {
		if (shipType !== 0 && shipLocationId != null) {
			dispatch(setCartActiveTab({ showTab: showTab + 1 }));
			dispatch(fetchPaymentCardListIfNeeded());
		}
	}
	// Render
	const totalAmount =
		shipType === SHIP_TYPES.DHL_EMPLEADOS
			? cartObject.Total * 1.16 + cartObject.Costo_Envio
			: cartObject.Total * 1.16;
	return (
		<div id="cart-content-2">
			<CartShipTo />
			<CartShipDealer />
			<div id="cart-summary">
				{/*<div id="cart-back">
					<FactoryButton shipType={this.props.shipType} isDisabled={true} />
				</div>*/}
				<div id="cart-coupon">&nbsp;</div>
				<div id="cart-totals">
					<div>
						<div>Subtotal</div>
						<div>{currencyFormat(cartObject.Total * 1.16)}</div>
					</div>
					<div>
						<div>Envío</div>
						<div>
							{currencyFormat(
								shipType === SHIP_TYPES.DHL_EMPLEADOS
									? cartObject.Costo_Envio
									: 0
							)}
						</div>
					</div>
					<div>
						<div className="totals">Total</div>
						<div>{currencyFormat(totalAmount)}</div>
					</div>
					<div>
						<div>Desglose IVA</div>
						<div>{currencyFormat(cartObject.Total * 0.16)} </div>
					</div>
					<div>
						<div>
							<div className="modal-button" onClick={handlePrevClick}>
								Anterior
							</div>
						</div>
						<div>
							<div
								className={getModalButtonClass(shipType === 0 || shipAddress == null)}
								onClick={handleNextClick}
							>
								Continuar
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
